import { ConfigProvider } from 'antd';
import { useSelector } from 'react-redux';
import { getAttachementPreviewOn } from 'Store/Activities/Activities.selector';
import {
  IDragAndDropDataFormat,
  ITopicDnDResponse,
} from 'Data/interfaces/Activities/IDragAndDropDataFormat';
import {
  IChangeStatus,
} from 'Data/interfaces/Activities/IChangeStatus';
import { IFiltroOptions } from 'Data/interfaces/Activities/IFilters';
import { INotificationInAppTopic } from 'Data/interfaces/Notification/INotification';
import Table from 'Components/UI/Table';
import useListVision from './useListVision';
import { Container } from './styles';

interface IListVision {
  csId: number;
  listActivities?: IDragAndDropDataFormat;
  height: number;
  searchActivity: string;
  endStatus?: IChangeStatus;
  showFilters?: boolean;
  filters?: Record<string, IFiltroOptions<ITopicDnDResponse>>;
  hasFilters: boolean;
  width: number;
  inAppTopicNotifications: INotificationInAppTopic[];
  onOpenCreateActivity: () => void;
  onOpenShowActivity: (activity: string) => void;
}

const ListVision = ({
  csId,
  listActivities,
  height,
  searchActivity,
  showFilters,
  filters,
  hasFilters,
  width,
  inAppTopicNotifications,
  onOpenCreateActivity,
  onOpenShowActivity,
}: IListVision) => {
  const attachementPreviewOn = useSelector(getAttachementPreviewOn);

  const {
    columns,
    filteredActivities,
    leftBarAndPaddingWidth,
    heightAndFiltersShow,
    renderEmpty,
  } = useListVision({
    csId,
    listActivities,
    height,
    searchActivity,
    filters,
    showFilters,
    hasFilters,
    inAppTopicNotifications,
    width,
    onOpenCreateActivity,
    onOpenShowActivity,
  });

  return (
    <Container>
      <ConfigProvider
        renderEmpty={renderEmpty}
      >
        <Table
          virtual
          scroll={{ y: heightAndFiltersShow, x: leftBarAndPaddingWidth }}
          columns={columns}
          dataSource={filteredActivities.map(
            (activity, index) => ({ ...activity, key: index })
          )}
          rowKey={(record: ITopicDnDResponse) => record.Guid}
          className="listTable"
          rowClassName="fileListRow"
          onRow={(record) => {
            return {
              onDoubleClick: () => attachementPreviewOn
                ? undefined
                : onOpenShowActivity(record.Guid),
            };
          }}
        />
      </ConfigProvider>
    </Container>
  );
}

export default ListVision;
